import { createContext } from "react";

// UI-only progress preferences for the obra table:
// - mode: "percentage" shows/edits progress as 0-100%, "amount" as the unit
//   quantity of the destajo's concepto.
// - inputType: how a typed value is interpreted — "acumulado" is the new running
//   total (the picker derives the delta), "diferencial" is the delta itself.
export const AvanceModeContext = createContext({
  mode: "percentage",
  inputType: "acumulado",
  setMode: () => {},
  setInputType: () => {},
});
